
import { ChallengeData } from "@/models/Base/ChallengeData";
import { Component, Vue, Prop } from "vue-property-decorator";
import ChallengeBox from "../../../Base/ChallengeBox.vue";
import ActionBox from "../../../Base/Actions/ActionBox.vue";
import {
  ActionRefData,
  QuestMapPoi,
  Quest_CG_MinigameSection,
} from "@/models/MapPois/Quest/QuestMapPoi";
import { Game } from "@/models/Game";
import {
  CodePuzzleData,
  AnagramPuzzleData,
  ColourMatchPuzzleData,
  ImageMatchPuzzleData,
  InventoryPickerPuzzle,
  LockpickPuzzleData,
  MapRunawayPuzzleData,
  MarbleMazePuzzle,
  MicPuzzleData,
  MINIGAME_TYPE,
  MultiChoicePuzzleData,
  NumberJumpPuzzleData,
  PoiPickerPuzzle,
  ShakePuzzleData,
  SweetSpotPuzzleData,
  PointTracePuzzleData,
  SwipeImgPuzzleData,
  SymbolTrainPuzzle,
  TapItPuzzleData,
  TilePuzzleData,
  LookSeekPuzzleData,
  FlingItPuzzleData,
  JigsawPuzzleData,
  OverlayPuzzleData,
} from "@/models/MapPois/Quest/Puzzle";
import { cloneDeep, isEqual } from "lodash";
import { ActionList } from "@/models/MapPois/Quest/Actions";
import { DropDownItem } from "@/models/Base/GlobalData";
import NumberJump from "./QuestMiniGameTabs/NumberJump.vue";
import ImgMatch from "./QuestMiniGameTabs/ImgMatch.vue";
import { Validations } from "vuelidate-property-decorators";
import {
  required,
  minLength,
  maxLength,
  numeric,
} from "vuelidate/lib/validators";
import CodeBreaker from "./QuestMiniGameTabs/CodeBreaker.vue";
import Anagram from "./QuestMiniGameTabs/Anagram.vue";
import ColourMatch from "./QuestMiniGameTabs/ColourMatch.vue";
import MultiChoice from "./QuestMiniGameTabs/MultiChoice.vue";
import Tap from "./QuestMiniGameTabs/Tap.vue";
import Tile from "./QuestMiniGameTabs/Tile.vue";
import MapRunaway from "./QuestMiniGameTabs/MapRunaway.vue";
import Shake from "./QuestMiniGameTabs/Shake.vue";
import SwipeImage from "./QuestMiniGameTabs/SwipeImage.vue";
import Microphone from "./QuestMiniGameTabs/Microphone.vue";
import Lockpick from "./QuestMiniGameTabs/Lockpick.vue";
import SweetSpot from "./QuestMiniGameTabs/SweetSpot.vue";
import SymbolTrain from "./QuestMiniGameTabs/SymbolTrain.vue";
import MarbleMaze from "./QuestMiniGameTabs/MarbleMaze.vue";
import InventoryPicker from "./QuestMiniGameTabs/InventoryPicker.vue";
import PoiPicker from "./QuestMiniGameTabs/PoiPicker.vue";
import PointTrace from "./QuestMiniGameTabs/PointTrace.vue";
import FlingIt from "./QuestMiniGameTabs/FlingIt.vue";
import LookSeek from "./QuestMiniGameTabs/LookSeek.vue";
import Jigsaw from "./QuestMiniGameTabs/Jigsaw.vue";
import OverlayPuzzle from "./QuestMiniGameTabs/OverlayPuzzle.vue";

@Component({
  components: {
    ChallengeBox,
    ActionBox,
    ImgMatch,
    NumberJump,
    CodeBreaker,
    Anagram,
    ColourMatch,
    MultiChoice,
    Tap,
    Tile,
    MapRunaway,
    Shake,
    SwipeImage,
    Microphone,
    Lockpick,
    SweetSpot,
    SymbolTrain,
    InventoryPicker,
    PoiPicker,
    MarbleMaze,
    PointTrace,
    FlingIt,
    LookSeek,
    Jigsaw,
    OverlayPuzzle,
  },
})
class PoiMiniGame extends Vue {
  @Prop({ default: null }) readonly mapPoi!: QuestMapPoi;
  @Prop({ default: false }) readonly isSavedOrDiscard!: boolean;
  @Prop({ default: null }) readonly contentString!: string;
  @Prop({ default: null }) readonly contentId!: number;
  @Prop({ default: true }) readonly isEditingLocked!: boolean;
  @Prop({ default: null }) readonly gameData!: Game;

  showSavePanel = false;
  cloneMapPoi = {} as QuestMapPoi;
  difficultyLevel = "default";
  updArray: any[] = [];
  lobbyTypeArray: string[] = ["solo", "group"];

  get getContentData(): Quest_CG_MinigameSection | undefined {
    return this.mapPoi.contentGroups[this.contentString].mg;
  }

  get getMaxAttempts(): number {
    if (this.getContentData?.type === "multi-choice") {
      return 2;
    } else {
      return 10;
    }
  }
  get getContentDataOnFail(): ActionList | undefined {
    if (
      this.difficultyLevel === "hard" &&
      this.getContentData?.puzzle.puzzleData.hard !== undefined
    ) {
      return this.getContentData.puzzle.puzzleData.hard.onFail?.actions;
    } else if (
      this.difficultyLevel === "easy" &&
      this.getContentData?.puzzle.puzzleData.easy !== undefined
    ) {
      return this.getContentData.puzzle.puzzleData.easy.onFail?.actions;
    } else if (
      this.difficultyLevel === "default" &&
      this.getContentData?.puzzle.puzzleData.default !== undefined
    ) {
      return this.getContentData.puzzle.puzzleData.default.onFail?.actions;
    } else {
      return {} as ActionList;
    }
  }
  get getContentDataTextOnFail(): string | undefined {
    if (
      this.difficultyLevel === "hard" &&
      this.getContentData?.puzzle.puzzleData.hard !== undefined
    ) {
      return this.getContentData.puzzle.puzzleData.hard.onFail?.txt?.en;
    } else if (
      this.difficultyLevel === "easy" &&
      this.getContentData?.puzzle.puzzleData.easy !== undefined
    ) {
      return this.getContentData.puzzle.puzzleData.easy.onFail?.txt?.en;
    } else if (
      this.difficultyLevel === "default" &&
      this.getContentData?.puzzle.puzzleData.default !== undefined
    ) {
      return this.getContentData.puzzle.puzzleData.default.onFail?.txt?.en;
    } else {
      return "";
    }
  }

  get getContentDataOnFinal(): ActionList | undefined {
    return (
      this.mapPoi.contentGroups[this.contentString].mg?.actions ||
      ({} as ActionList)
    );
  }

  get getContentDataOnSuccess(): ActionList | undefined {
    if (
      this.difficultyLevel === "hard" &&
      this.getContentData?.puzzle.puzzleData.hard !== undefined
    ) {
      return this.getContentData.puzzle.puzzleData.hard.onSuccess?.actions;
    } else if (
      this.difficultyLevel === "easy" &&
      this.getContentData?.puzzle.puzzleData.easy !== undefined
    ) {
      return this.getContentData.puzzle.puzzleData.easy.onSuccess?.actions;
    } else if (
      this.difficultyLevel === "default" &&
      this.getContentData?.puzzle.puzzleData.default !== undefined
    ) {
      return this.getContentData.puzzle.puzzleData.default.onSuccess?.actions;
    } else {
      return {} as ActionList;
    }
  }
  get getContentDataTextOnSuccess(): string | undefined {
    if (
      this.difficultyLevel === "hard" &&
      this.getContentData?.puzzle.puzzleData.hard !== undefined
    ) {
      return this.getContentData.puzzle.puzzleData.hard.onSuccess?.txt?.en;
    } else if (
      this.difficultyLevel === "easy" &&
      this.getContentData?.puzzle.puzzleData.easy !== undefined
    ) {
      return this.getContentData.puzzle.puzzleData.easy.onSuccess?.txt?.en;
    } else if (
      this.difficultyLevel === "default" &&
      this.getContentData?.puzzle.puzzleData.default !== undefined
    ) {
      return this.getContentData.puzzle.puzzleData.default.onSuccess?.txt?.en;
    } else {
      return "";
    }
  }
  get getContentDataOnIncorrect(): ActionList | undefined {
    if (
      this.difficultyLevel === "hard" &&
      this.getContentData?.puzzle.puzzleData.hard !== undefined
    ) {
      return this.getContentData.puzzle.puzzleData.hard.onIncorrect?.actions;
    } else if (
      this.difficultyLevel === "easy" &&
      this.getContentData?.puzzle.puzzleData.easy !== undefined
    ) {
      return this.getContentData.puzzle.puzzleData.easy.onIncorrect?.actions;
    } else if (
      this.difficultyLevel === "default" &&
      this.getContentData?.puzzle.puzzleData.default !== undefined
    ) {
      return this.getContentData.puzzle.puzzleData.default.onIncorrect?.actions;
    } else {
      return {} as ActionList;
    }
  }
  get getContentDataTextOnIncorrect(): string | undefined {
    if (
      this.difficultyLevel === "hard" &&
      this.getContentData!.puzzle.puzzleData.hard !== undefined
    ) {
      return this.getContentData?.puzzle.puzzleData.hard.onIncorrect?.txt?.en;
    } else if (
      this.difficultyLevel === "easy" &&
      this.getContentData?.puzzle.puzzleData.easy !== undefined
    ) {
      return this.getContentData.puzzle.puzzleData.easy.onIncorrect?.txt?.en;
    } else if (
      this.difficultyLevel === "default" &&
      this.getContentData?.puzzle.puzzleData.default !== undefined
    ) {
      return this.getContentData.puzzle.puzzleData.default.onIncorrect?.txt?.en;
    } else {
      return "";
    }
  }

  get getChallengeData(): ChallengeData {
    const challengeData = {} as ChallengeData;
    try {
      challengeData.text = this.getContentData?.intro.txt.en || "";
      challengeData.image = this.getContentData?.intro.imgs || "";
      challengeData.video = { en: "" };
      if (this.getContentData?.intro.audio === undefined) {
        challengeData.audio = { en: "" };
      } else {
        challengeData.audio = this.getContentData.intro.audio;
      }
      return challengeData;
    } catch (error) {
      console.log(error);
      return challengeData;
    }
  }

  get getTutorialData(): ChallengeData {
    const challengeData = {} as ChallengeData;
    try {
      challengeData.text = this.getContentData?.puzzle.tutorial.txt.en || "";
      challengeData.image = this.getContentData?.puzzle.tutorial.imgs || "";
      challengeData.video = { en: "" };
      if (this.getContentData?.puzzle.tutorial.audio === undefined) {
        challengeData.audio = { en: "" };
      } else {
        challengeData.audio = this.getContentData.puzzle.tutorial.audio;
      }
      return challengeData;
    } catch (error) {
      console.log(error);
      return challengeData;
    }
  }

  get getPuzzleType(): string[] {
    return Object.values(MINIGAME_TYPE);
  }

  get getDifficultyType(): DropDownItem[] {
    const difficultArray = [{ text: "Default", value: "default" }];
    if (this.getContentData?.puzzle.puzzleData.easy !== undefined) {
      difficultArray.push({ text: "Easy", value: "easy" });
    } else {
      difficultArray.push({ text: "Easy (Unused)", value: "easy" });
    }
    if (this.getContentData?.puzzle.puzzleData.hard !== undefined) {
      difficultArray.push({ text: "Hard", value: "hard" });
    } else {
      difficultArray.push({ text: "Hard (Unused)", value: "hard" });
    }
    return difficultArray;
  }

  get getImagePath(): string {
    return (
      "/gametype/" +
      this.gameData.gt_uid +
      "/seasons/" +
      this.gameData.seas_uid +
      "/img/puzzle/"
    );
  }

  get getAudioPath(): string {
    return (
      "/gametype/" +
      this.gameData.gt_uid +
      "/seasons/" +
      this.gameData.seas_uid +
      "/audio/puzzle/"
    );
  }

  created(): void {
    this.cloneMapPoi = cloneDeep(this.mapPoi);
    this.$v.$touch();
  }
  getTutorialDataDefault(): ChallengeData {
    var challengeData = {} as ChallengeData;
    if (this.getContentData?.type === MINIGAME_TYPE.MULTI_CHOICE) {
      challengeData.text = "Select the answer from the given options!";
    }
    if (this.getContentData?.type === MINIGAME_TYPE.CODE) {
      challengeData.text = "Select the answer from the given options!";
    }
    if (this.getContentData?.type === MINIGAME_TYPE.ANAGRAM) {
      challengeData.text = "Select the answer from the given options!";
    }
    if (this.getContentData?.type === MINIGAME_TYPE.JIGSAW) {
      challengeData.text = "earrange the pieces!";
    }
    if (this.getContentData?.type === MINIGAME_TYPE.LOCKPICK) {
      challengeData.text = "Select the answer from the given options!";
    }
    if (this.getContentData?.type === MINIGAME_TYPE.TILE) {
      challengeData.text = "Select the answer from the given options!";
    }
    if (this.getContentData?.type === MINIGAME_TYPE.MIC) {
      challengeData.text = "Select the answer from the given options!";
    }
    if (this.getContentData?.type === MINIGAME_TYPE.SHAKE) {
      challengeData.text = "Select the answer from the given options!";
    }
    if (this.getContentData?.type === MINIGAME_TYPE.SWIPE_IMG) {
      challengeData.text = "Select the answer from the given options!";
    }
    if (this.getContentData?.type === MINIGAME_TYPE.TAP) {
      challengeData.text = "Tap to win!";
    }
    return challengeData;
  }

  onValueChanged(): void {
    if (!isEqual(this.mapPoi, this.cloneMapPoi)) {
      this.showSavePanel = true;
    } else {
      this.showSavePanel = false;
    }
    this.$emit("updateTempObject", this.mapPoi);
  }

  onIntroDataChange(challenge: ChallengeData): void {
    if (this.getContentData !== undefined) {
      this.getContentData.intro.txt.en = challenge.text;
      this.getContentData.intro.imgs = challenge.image;
      this.getContentData.intro.audio = challenge.audio || { en: "" };
      this.onValueChanged();
    }
  }

  onTutorialDataChange(challenge: ChallengeData): void {
    if (this.getContentData !== undefined) {
      this.getContentData.puzzle.tutorial.txt.en = challenge.text;
      this.getContentData.puzzle.tutorial.imgs = challenge.image;
      this.getContentData.puzzle.tutorial.audio = challenge.audio || { en: "" };
      this.onValueChanged();
    }
  }

  updateFail(contentData: any): void {
    this.addActionRefActions(contentData, "onFail");
    if (this.difficultyLevel === "default") {
      this.getContentData!.puzzle.puzzleData.default.onFail = {
        txt: { en: contentData.txt },
        actions: contentData.contentData,
      };
    }
    if (this.difficultyLevel === "easy") {
      if (this.getContentData?.puzzle.puzzleData.easy !== undefined) {
        this.getContentData.puzzle.puzzleData.easy.onFail = {
          txt: { en: contentData.txt },
          actions: contentData.contentData,
        };
      }
    }
    if (this.difficultyLevel === "hard") {
      if (this.getContentData?.puzzle.puzzleData.hard !== undefined) {
        this.getContentData.puzzle.puzzleData.hard.onFail = {
          txt: { en: contentData.txt },
          actions: contentData.contentData,
        };
      }
    }
    this.onValueChanged();
  }
  updateSuccess(contentData: any): void {
    this.addActionRefActions(contentData, "onSuccess");
    if (this.difficultyLevel === "default") {
      this.getContentData!.puzzle.puzzleData.default.onSuccess = {
        txt: { en: contentData.txt },
        actions: contentData.contentData,
      };
    }
    if (this.difficultyLevel === "easy") {
      if (this.getContentData?.puzzle.puzzleData.easy !== undefined) {
        this.getContentData.puzzle.puzzleData.easy.onSuccess = {
          txt: { en: contentData.txt },
          actions: contentData.contentData,
        };
      }
    }
    if (this.difficultyLevel === "hard") {
      if (this.getContentData?.puzzle.puzzleData.hard !== undefined) {
        this.getContentData.puzzle.puzzleData.hard.onSuccess = {
          txt: { en: contentData.txt },
          actions: contentData.contentData,
        };
      }
    }
    this.onValueChanged();
  }
  updateIncorrect(contentData: any): void {
    this.addActionRefActions(contentData, "onIncorrect");
    if (this.difficultyLevel === "default") {
      this.getContentData!.puzzle.puzzleData.default.onIncorrect = {
        txt: { en: contentData.txt },
        actions: contentData.contentData,
      };
    }
    if (this.difficultyLevel === "easy") {
      if (this.getContentData?.puzzle.puzzleData.easy !== undefined) {
        this.getContentData.puzzle.puzzleData.easy.onIncorrect = {
          txt: { en: contentData.txt },
          actions: contentData.contentData,
        };
      }
    }
    if (this.difficultyLevel === "hard") {
      if (this.getContentData?.puzzle.puzzleData.hard !== undefined) {
        this.getContentData.puzzle.puzzleData.hard.onIncorrect = {
          txt: { en: contentData.txt },
          actions: contentData.contentData,
        };
      }
    }
    this.onValueChanged();
  }

  updateFinal(contentData: any): void {
    this.addActionRefActionsFinal(contentData);
    if (this.getContentData !== undefined) {
      this.getContentData.actions = contentData.contentData;
    }
    this.onValueChanged();
  }

  deleteActionFinal(contentData: any): void {
    if (this.getContentData?.actions !== undefined) {
      this.getContentData.actions = contentData.contentData;
      this.deleteActionRefActionFinal(contentData);
      var data = {
        mapPoi: this.mapPoi,
        game_uid: this.gameData.key,
      };
      this.$store.dispatch("mapPoiStore/updateMapPoiType", data);
    }
  }

  deleteActionFail(contentData: any): void {
    if (this.difficultyLevel === "default") {
      this.getContentData!.puzzle.puzzleData.default.onFail = {
        txt: { en: contentData.txt },
        actions: contentData.contentData,
      };
    }
    if (this.difficultyLevel === "easy") {
      if (this.getContentData?.puzzle.puzzleData.easy !== undefined) {
        this.getContentData.puzzle.puzzleData.easy.onFail = {
          txt: { en: contentData.txt },
          actions: contentData.contentData,
        };
      }
    }
    if (this.difficultyLevel === "hard") {
      if (this.getContentData?.puzzle.puzzleData.hard !== undefined) {
        this.getContentData.puzzle.puzzleData.hard.onFail = {
          txt: { en: contentData.txt },
          actions: contentData.contentData,
        };
      }
    }
    this.deleteActionRefAction(contentData, "onFail");
    var data = {
      mapPoi: this.mapPoi,
      game_uid: this.gameData.key,
    };
    this.$store.dispatch("mapPoiStore/updateMapPoiType", data);
  }
  deleteActionIncorrect(contentData: any): void {
    if (this.difficultyLevel === "default") {
      this.getContentData!.puzzle.puzzleData.default.onIncorrect = {
        txt: { en: contentData.txt },
        actions: contentData.contentData,
      };
    }
    if (this.difficultyLevel === "easy") {
      if (this.getContentData?.puzzle.puzzleData.easy !== undefined) {
        this.getContentData.puzzle.puzzleData.easy.onIncorrect = {
          txt: { en: contentData.txt },
          actions: contentData.contentData,
        };
      }
    }
    if (this.difficultyLevel === "hard") {
      if (this.getContentData?.puzzle.puzzleData.hard !== undefined) {
        this.getContentData.puzzle.puzzleData.hard.onIncorrect = {
          txt: { en: contentData.txt },
          actions: contentData.contentData,
        };
      }
    }
    this.deleteActionRefAction(contentData, "onIncorrect");
    var data = {
      mapPoi: this.mapPoi,
      game_uid: this.gameData.key,
    };
    this.$store.dispatch("mapPoiStore/updateMapPoiType", data);
  }
  deleteActionSuccess(contentData: any): void {
    if (this.difficultyLevel === "default") {
      this.getContentData!.puzzle.puzzleData.default.onSuccess = {
        txt: { en: contentData.txt },
        actions: contentData.contentData,
      };
    }
    if (this.difficultyLevel === "easy") {
      if (this.getContentData?.puzzle.puzzleData.easy !== undefined) {
        this.getContentData.puzzle.puzzleData.easy.onSuccess = {
          txt: { en: contentData.txt },
          actions: contentData.contentData,
        };
      }
    }
    if (this.difficultyLevel === "hard") {
      if (this.getContentData?.puzzle.puzzleData.hard !== undefined) {
        this.getContentData.puzzle.puzzleData.hard.onSuccess = {
          txt: { en: contentData.txt },
          actions: contentData.contentData,
        };
      }
    }
    this.deleteActionRefAction(contentData, "onSuccess");
    var data = {
      mapPoi: this.mapPoi,
      game_uid: this.gameData.key,
    };
    this.$store.dispatch("mapPoiStore/updateMapPoiType", data);
  }

  addActionRefActions(contentData: any, type: string): void {
    try {
      if (this.mapPoi.actionGoalRef === undefined) {
        this.mapPoi.actionGoalRef = [];
      }
      this.deleteActionRefAction(contentData, type);
      var actionItems = Object.values(contentData.actionDetails.upd);
      actionItems.forEach((x: any) => {
        var data: ActionRefData = {
          id: x.id,
          helperPath: this.getHelperPath(contentData.objectName, type),
          path: this.getRealPath(contentData.objectName, type),
        };
        this.mapPoi.actionGoalRef?.push(data);
      });
    } catch (error) {
      console.log(error);
    }
  }

  addActionRefActionsFinal(contentData: any): void {
    try {
      if (this.mapPoi.actionGoalRef === undefined) {
        this.mapPoi.actionGoalRef = [];
      }
      this.deleteActionRefActionFinal(contentData);
      var actionItems = Object.values(contentData.actionDetails.upd);
      actionItems.forEach((x: any) => {
        var data: ActionRefData = {
          id: x.id,
          helperPath: this.getHelperPathFinal(contentData.objectName),
          path: this.getRealPathFinal(contentData.objectName),
        };
        this.mapPoi.actionGoalRef?.push(data);
      });
    } catch (error) {
      console.log(error);
    }
  }

  onLobbyTypeChange(): void {
    if (this.getContentData!.puzzle.lobbyType === "group") {
      this.getContentData!.puzzle.dismissable = false;
    }
    this.onValueChanged();
  }

  deleteOnChangeActionRef(contentGroup: string): void {
    var data = this.mapPoi.actionGoalRef?.filter(
      (x: any) =>
        x.path.includes(contentGroup) &&
        x.path.includes("mg") &&
        (x.path.includes("onIncorect") ||
          x.path.includes("onSuccess") ||
          x.path.includes("onFail"))
    );
    data?.forEach((x) => {
      this.mapPoi.actionGoalRef?.splice(
        this.mapPoi.actionGoalRef?.indexOf(x),
        1
      );
    });
  }

  deleteActionRefAction(contentData: any, type: string): void {
    var data = this.mapPoi.actionGoalRef?.filter(
      (x: any) => x.path === this.getRealPath(contentData.objectName, type)
    );
    data?.forEach((x) => {
      this.mapPoi.actionGoalRef?.splice(
        this.mapPoi.actionGoalRef?.indexOf(x),
        1
      );
    });
  }
  deleteActionRefActionFinal(contentData: any): void {
    var data = this.mapPoi.actionGoalRef?.filter(
      (x: any) => x.path === this.getRealPathFinal(contentData.objectName)
    );
    data?.forEach((x) => {
      this.mapPoi.actionGoalRef?.splice(
        this.mapPoi.actionGoalRef?.indexOf(x),
        1
      );
    });
  }

  getHelperPath(objectName: string, type: string): string {
    return (
      this.mapPoi.title.en +
      "/" +
      "Content Group" +
      this.contentId +
      "/mg/puzzle/puzzleData/" +
      this.difficultyLevel +
      "/" +
      type +
      "/actions/" +
      objectName
    );
  }
  getRealPath(objectName: string, type: string): string {
    return (
      this.mapPoi.key +
      "/contentGroups/" +
      this.contentString +
      "/mg/puzzle/puzzleData/" +
      this.difficultyLevel +
      "/" +
      type +
      "/actions/" +
      objectName
    );
  }
  getHelperPathFinal(objectName: string): string {
    return (
      this.mapPoi.title.en +
      "/" +
      "Content Group" +
      this.contentId +
      "/mg/actions/" +
      objectName
    );
  }
  getRealPathFinal(objectName: string): string {
    return (
      this.mapPoi.key +
      "/contentGroups/" +
      this.contentString +
      "/mg/actions/" +
      objectName
    );
  }

  setEmptyMultiChoiceData(): MultiChoicePuzzleData {
    return {
      q: { txt: { en: "" }, imgs: "", audio: { en: "" } },
      a: {
        a0: { correct: false, txt: { en: "" } },
        a1: { correct: false, txt: { en: "" } },
        a2: { correct: false, txt: { en: "" } },
      },
      onFail: {
        txt: { en: "Failed!" },
        actions: {
          timerAction: { value: 5, parentID: "", status: "" },
        },
      },
      onSuccess: {
        txt: { en: "Success!" },
      },
      onIncorrect: {
        txt: { en: "Oops!" },
        actions: {
          timerAction: { value: 1, parentID: "", status: "" },
        },
      },
    };
  }

  setCodePuzzleData(): CodePuzzleData {
    return {
      q: { txt: { en: "" }, imgs: "", audio: { en: "" } },
      a: {
        txt: { en: "" },
      },
      onFail: {
        txt: { en: "Failed!" },
        actions: {
          timerAction: { value: 5, parentID: "", status: "" },
        },
      },
      onSuccess: {
        txt: { en: "Success!" },
      },
      onIncorrect: {
        txt: { en: "Oops!" },
        actions: {
          timerAction: { value: 1, parentID: "", status: "" },
        },
      },
    };
  }
  setAnagramPuzzleData(): AnagramPuzzleData {
    return {
      q: { txt: { en: "" }, imgs: "", audio: { en: "" } },
      a: {
        txt: { en: "" },
      },
      onFail: {
        txt: { en: "Failed!" },
        actions: {
          timerAction: { value: 5, parentID: "", status: "" },
        },
      },
      onSuccess: {
        txt: { en: "Success!" },
      },
      onIncorrect: {
        txt: { en: "Oops!" },
        actions: {
          timerAction: { value: 1, parentID: "", status: "" },
        },
      },
    };
  }

  setLockPickPuzzleData(): LockpickPuzzleData {
    return {
      pins: 5,
      speed: 3,
      scale: 3,
      onFail: {
        txt: { en: "Failed!" },
        actions: {
          timerAction: { value: 5, parentID: "", status: "" },
        },
      },
      onSuccess: {
        txt: { en: "Success!" },
      },
      onIncorrect: {
        txt: { en: "Oops!" },
        actions: {
          timerAction: { value: 1, parentID: "", status: "" },
        },
      },
    };
  }
  setOverlayPuzzleData(): OverlayPuzzleData {
    return {
      numRounds: 5,
      onFail: {
        txt: { en: "Failed!" },
        actions: {
          timerAction: { value: 5, parentID: "", status: "" },
        },
      },
      onSuccess: {
        txt: { en: "Success!" },
      },
      onIncorrect: {
        txt: { en: "Oops!" },
        actions: {
          timerAction: { value: 1, parentID: "", status: "" },
        },
      },
    };
  }
  setTilePuzzleData(): TilePuzzleData {
    return {
      divs: 3,
      shuffles: 5,
      onFail: {
        txt: { en: "Failed!" },
        actions: {
          timerAction: { value: 5, parentID: "", status: "" },
        },
      },
      onSuccess: {
        txt: { en: "Success!" },
      },
      onIncorrect: {
        txt: { en: "Oops!" },
        actions: {
          timerAction: { value: 1, parentID: "", status: "" },
        },
      },
    };
  }

  onDismissableChange(): void {
    if (this.getContentData?.puzzle.dismissable) {
      this.getContentData.puzzle.attempts = 0;
      this.getContentData.puzzle.timeout_s = 0;
    }
    this.onValueChanged();
  }
  setMicrophoneData(): MicPuzzleData {
    return {
      bleedRate_Scalar: 0.5,
      onFail: {
        txt: { en: "Failed!" },
        actions: {
          timerAction: { value: 5, parentID: "", status: "" },
        },
      },
      onSuccess: {
        txt: { en: "Success!" },
      },
      onIncorrect: {
        txt: { en: "Oops!" },
        actions: {
          timerAction: { value: 1, parentID: "", status: "" },
        },
      },
    };
  }
  setShakeData(): ShakePuzzleData {
    return {
      bleedRate_Scalar: 0.5,
      onFail: {
        txt: { en: "Failed!" },
        actions: {
          timerAction: { value: 5, parentID: "", status: "" },
        },
      },
      onSuccess: {
        txt: { en: "Success!" },
      },
      onIncorrect: {
        txt: { en: "Oops!" },
        actions: {
          timerAction: { value: 1, parentID: "", status: "" },
        },
      },
    };
  }
  setSwipeImageData(): SwipeImgPuzzleData {
    return {
      imgs: [],
      completionPc: 50,
      onFail: {
        txt: { en: "Failed!" },
        actions: {
          timerAction: { value: 5, parentID: "", status: "" },
        },
      },
      onSuccess: {
        txt: { en: "Success!" },
      },
      onIncorrect: {
        txt: { en: "Oops!" },
        actions: {
          timerAction: { value: 1, parentID: "", status: "" },
        },
      },
    };
  }
  setJigsawPuzzleData(): JigsawPuzzleData {
    return {
      imgs: "",
      cells: 8,
      helper: false,
      onFail: {
        txt: { en: "Failed!" },
        actions: {
          timerAction: { value: 5, parentID: "", status: "" },
        },
      },
      onSuccess: {
        txt: { en: "Success!" },
      },
      onIncorrect: {
        txt: { en: "Oops!" },
        actions: {
          timerAction: { value: 1, parentID: "", status: "" },
        },
      },
    };
  }

  setTapItData(): TapItPuzzleData {
    return {
      bleedRate_Scalar: 0.5,
      onFail: {
        txt: { en: "Failed!" },
        actions: {
          timerAction: { value: 5, parentID: "", status: "" },
        },
      },
      onSuccess: {
        txt: { en: "Success!" },
      },
      onIncorrect: {
        txt: { en: "Oops!" },
        actions: {
          timerAction: { value: 1, parentID: "", status: "" },
        },
      },
    };
  }
  setMapRunawayData(): MapRunawayPuzzleData {
    return {
      targets: {},
      timeout_Adjust_s: 0,
      onFail: {
        txt: { en: "Failed!" },
        actions: {
          timerAction: { value: 5, parentID: "", status: "" },
        },
      },
      onSuccess: {
        txt: { en: "Success!" },
      },
      onIncorrect: {
        txt: { en: "Oops!" },
        actions: {
          timerAction: { value: 1, parentID: "", status: "" },
        },
      },
    };
  }
  setColourMatchData(): ColourMatchPuzzleData {
    return {
      numRounds: 10,
      sPerRound: 2,
      colorIDs: { en: "AlphaGreen" },
      onFail: {
        txt: { en: "Failed!" },
        actions: {
          timerAction: { value: 5, parentID: "", status: "" },
        },
      },
      onSuccess: {
        txt: { en: "Success!" },
      },
      onIncorrect: {
        txt: { en: "Oops!" },
        actions: {
          timerAction: { value: 1, parentID: "", status: "" },
        },
      },
    };
  }

  setImageMatchData(): ImageMatchPuzzleData {
    return {
      numRounds: 10,
      cells: 15,
      onFail: {
        txt: { en: "Failed!" },
        actions: {
          timerAction: { value: 5, parentID: "", status: "" },
        },
      },
      onSuccess: {
        txt: { en: "Success!" },
      },
      onIncorrect: {
        txt: { en: "Oops!" },
        actions: {
          timerAction: { value: 1, parentID: "", status: "" },
        },
      },
    };
  }
  setNumberJumpData(): NumberJumpPuzzleData {
    return {
      maxRange: 10,
      numRounds: 5,
      cells: 4,
      onFail: {
        txt: { en: "Failed!" },
        actions: {
          timerAction: { value: 5, parentID: "", status: "" },
        },
      },
      onSuccess: {
        txt: { en: "Success!" },
      },
      onIncorrect: {
        txt: { en: "Oops!" },
        actions: {
          timerAction: { value: 1, parentID: "", status: "" },
        },
      },
    };
  }
  setSymbolTrainData(): SymbolTrainPuzzle {
    return {
      num_targets: 3,
      speed: 0.5,
      onFail: {
        txt: { en: "Failed!" },
        actions: {
          timerAction: { value: 5, parentID: "", status: "" },
        },
      },
      onSuccess: {
        txt: { en: "Success!" },
      },
      onIncorrect: {
        txt: { en: "Oops!" },
        actions: {
          timerAction: { value: 1, parentID: "", status: "" },
        },
      },
    };
  }
  setSweetSpotData(): SweetSpotPuzzleData {
    return {
      target_val: 0.5,
      speed: 0.5,
      range_pc: 0.5,
      onFail: {
        txt: { en: "Failed!" },
        actions: {
          timerAction: { value: 5, parentID: "", status: "" },
        },
      },
      onSuccess: {
        txt: { en: "Success!" },
      },
      onIncorrect: {
        txt: { en: "Oops!" },
        actions: {
          timerAction: { value: 1, parentID: "", status: "" },
        },
      },
    };
  }
  setMarbleMazeData(): MarbleMazePuzzle {
    return {
      numRounds: 3,
      map: "",
      onFail: {
        txt: { en: "Failed!" },
        actions: {
          timerAction: { value: 5, parentID: "", status: "" },
        },
      },
      onSuccess: {
        txt: { en: "Success!" },
      },
      onIncorrect: {
        txt: { en: "Oops!" },
        actions: {
          timerAction: { value: 1, parentID: "", status: "" },
        },
      },
    };
  }

  setInventoryPickerData(): InventoryPickerPuzzle {
    return {
      q: { txt: { en: "" }, imgs: "", audio: { en: "" } },
      inv_targets: {},
      onFail: {
        txt: { en: "Failed!" },
        actions: {
          timerAction: { value: 5, parentID: "", status: "" },
        },
      },
      onSuccess: {
        txt: { en: "Success!" },
      },
      onIncorrect: {
        txt: { en: "Oops!" },
        actions: {
          timerAction: { value: 1, parentID: "", status: "" },
        },
      },
    };
  }
  setLookSeekData(): LookSeekPuzzleData {
    return {
      targetImgs: [],
      gridDivs: 8,
      onFail: {
        txt: { en: "Failed!" },
        actions: {
          timerAction: { value: 5, parentID: "", status: "" },
        },
      },
      onSuccess: {
        txt: { en: "Success!" },
      },
      onIncorrect: {
        txt: { en: "Oops!" },
        actions: {
          timerAction: { value: 1, parentID: "", status: "" },
        },
      },
    };
  }
  setFlingItPuzzleData(): FlingItPuzzleData {
    return {
      ammoCount: 20,
      hitGoal: 10,
      onFail: {
        txt: { en: "Failed!" },
        actions: {
          timerAction: { value: 5, parentID: "", status: "" },
        },
      },
      onSuccess: {
        txt: { en: "Success!" },
      },
      onIncorrect: {
        txt: { en: "Oops!" },
        actions: {
          timerAction: { value: 1, parentID: "", status: "" },
        },
      },
    };
  }

  setPoiPickerData(): PoiPickerPuzzle {
    return {
      q: { txt: { en: "" }, imgs: "", audio: { en: "" } },
      poi_targets: {},
      onFail: {
        txt: { en: "Failed!" },
        actions: {
          timerAction: { value: 5, parentID: "", status: "" },
        },
      },
      onSuccess: {
        txt: { en: "Success!" },
      },
      onIncorrect: {
        txt: { en: "Oops!" },
        actions: {
          timerAction: { value: 1, parentID: "", status: "" },
        },
      },
    };
  }

  setPointTraceData(): PointTracePuzzleData {
    return {
      hitMap: "",
      imgBackdrop: "",
      bailOnHit: false,
      showOrderHints: false,
      onFail: {
        txt: { en: "Failed!" },
        actions: {
          timerAction: { value: 5, parentID: "", status: "" },
        },
      },
      onSuccess: {
        txt: { en: "Success!" },
      },
      onIncorrect: {
        txt: { en: "Oops!" },
        actions: {
          timerAction: { value: 1, parentID: "", status: "" },
        },
      },
    };
  }
  onMiniGameChange(): void {
    var type = this.cloneMapPoi.contentGroups[this.contentString].mg?.type;
    if (this.getContentData?.type === type) {
      this.getContentData!.puzzle = this.cloneMapPoi.contentGroups[
        this.contentString
      ].mg!.puzzle;
      this.onValueChanged();
    } else {
      if (this.getContentData !== undefined) {
        this.deleteOnChangeActionRef(this.contentString);
        this.difficultyLevel = "default";
        delete this.getContentData.puzzle.puzzleData.easy;
        delete this.getContentData.puzzle.puzzleData.hard;
        if (this.getContentData?.type === MINIGAME_TYPE.MULTI_CHOICE) {
          this.getContentData.puzzle.puzzleData.default = this.setEmptyMultiChoiceData();
          this.getContentData.puzzle.lobbyType = "solo";
          this.getContentData.puzzle.tutorial.title.en = "Multiple Choice";
          this.getContentData.puzzle.tutorial.imgs = "";
          this.getContentData.puzzle.tutorial.txt.en =
            "Select the answer from the given options!";
        }
        if (this.getContentData?.type === MINIGAME_TYPE.CODE) {
          this.getContentData.puzzle.puzzleData.default = this.setCodePuzzleData();
          this.getContentData.puzzle.lobbyType = "solo";
          this.getContentData.puzzle.tutorial.title.en = "CodeBreaker";
          this.getContentData.puzzle.tutorial.imgs = "";
          this.getContentData.puzzle.tutorial.txt.en =
            "Input the correct answer";
        }
        if (this.getContentData?.type === MINIGAME_TYPE.ANAGRAM) {
          this.getContentData.puzzle.puzzleData.default = this.setCodePuzzleData();
          this.getContentData.puzzle.lobbyType = "group";
          this.getContentData.puzzle.tutorial.title.en = "Anagram";
          this.getContentData.puzzle.tutorial.imgs = "";
          this.getContentData.puzzle.tutorial.txt.en =
            "Rearrange the letters into the answer!";
        }
        if (this.getContentData?.type === MINIGAME_TYPE.LOCKPICK) {
          this.getContentData.puzzle.puzzleData.default = this.setLockPickPuzzleData();
          this.getContentData.puzzle.lobbyType = "group";
          this.getContentData.puzzle.tutorial.title.en = "Lockpick";
          this.getContentData.puzzle.tutorial.imgs = "";
          this.getContentData.puzzle.tutorial.txt.en =
            "Tap the screen in the sweet spot to lock each pin";
        }
        if (this.getContentData?.type === MINIGAME_TYPE.TILE) {
          this.getContentData.puzzle.puzzleData.default = this.setTilePuzzleData();
          this.getContentData.puzzle.tutorial.title.en = "Tile Puzzle";
          this.getContentData.puzzle.lobbyType = "group";
          this.getContentData.puzzle.tutorial.imgs = "";
          this.getContentData.puzzle.tutorial.txt.en =
            "Slide the pieces to uncover the image";
        }
        if (this.getContentData?.type === MINIGAME_TYPE.MIC) {
          this.getContentData.puzzle.puzzleData.default = this.setMicrophoneData();
          this.getContentData.puzzle.lobbyType = "group";
          this.getContentData.puzzle.tutorial.title.en = "Make some Noise";
          this.getContentData.puzzle.tutorial.txt.en = "Shout into the Mic!";
          this.getContentData.puzzle.tutorial.imgs = "";
          this.getContentData.puzzle.attempts = 0;
        }
        if (this.getContentData?.type === MINIGAME_TYPE.SHAKE) {
          this.getContentData.puzzle.puzzleData.default = this.setShakeData();
          this.getContentData.puzzle.lobbyType = "group";
          this.getContentData.puzzle.tutorial.title.en = "Shake it!";
          this.getContentData.puzzle.tutorial.txt.en = "Shake your device!";
          this.getContentData.puzzle.tutorial.imgs = "";
          this.getContentData.puzzle.attempts = 0;
        }
        if (this.getContentData?.type === MINIGAME_TYPE.SWIPE_IMG) {
          this.getContentData.puzzle.puzzleData.default = this.setSwipeImageData();
          this.getContentData.puzzle.lobbyType = "group";
          this.getContentData.puzzle.tutorial.title.en = "Swipe it!";
          this.getContentData.puzzle.tutorial.imgs = "";
          this.getContentData.puzzle.tutorial.txt.en =
            "Swipe the image to reveal";
        }
        if (this.getContentData?.type === MINIGAME_TYPE.TAP) {
          this.getContentData.puzzle.puzzleData.default = this.setTapItData();
          this.getContentData.puzzle.lobbyType = "group";
          this.getContentData.puzzle.tutorial.title.en = "Tap it!";
          this.getContentData.puzzle.tutorial.txt.en = "Tap to win!";
          this.getContentData.puzzle.tutorial.imgs = "";
          this.getContentData.puzzle.attempts = 0;
          this.getContentData.puzzle.timeout_s = 60;
        }
        if (this.getContentData?.type === MINIGAME_TYPE.MAP_RUNAWAY) {
          this.getContentData.puzzle.puzzleData.default = this.setMapRunawayData();
          this.getContentData.puzzle.lobbyType = "solo";
          this.getContentData.puzzle.tutorial.title.en = "Map Runaway!";
          this.getContentData.puzzle.tutorial.txt.en =
            "Reach the target within the time limit!";
          this.getContentData.puzzle.tutorial.imgs = "";
          this.getContentData.puzzle.attempts = 0;
          this.getContentData.puzzle.timeout_s = 300;
        }
        if (this.getContentData?.type === MINIGAME_TYPE.COLOUR_MATCH) {
          this.getContentData.puzzle.puzzleData.default = this.setColourMatchData();
          this.getContentData.puzzle.lobbyType = "group";
          this.getContentData.puzzle.tutorial.title.en = "Colour Match!";
          this.getContentData.puzzle.tutorial.txt.en =
            "Press the COLOUR shown (Not the word)";
          this.getContentData.puzzle.tutorial.imgs = "";
          this.getContentData.puzzle.attempts = 0;
          this.getContentData.puzzle.timeout_s = 0;
        }
        if (this.getContentData.type === MINIGAME_TYPE.IMAGE_MATCH) {
          this.getContentData.puzzle.puzzleData.default = this.setImageMatchData();
          this.getContentData.puzzle.lobbyType = "group";
          this.getContentData.puzzle.tutorial.title.en = "Image Match";
          this.getContentData.puzzle.tutorial.txt.en =
            "Find 2 of the same item!";
          this.getContentData.puzzle.tutorial.imgs = "";
          this.getContentData.puzzle.attempts = 0;
          this.getContentData.puzzle.timeout_s = 0;
        }
        if (this.getContentData.type === MINIGAME_TYPE.NUMBER_JUMP) {
          this.getContentData.puzzle.puzzleData.default = this.setNumberJumpData();
          this.getContentData.puzzle.lobbyType = "group";
          this.getContentData.puzzle.tutorial.title.en = "Number Jump";
          this.getContentData.puzzle.tutorial.txt.en =
            "Tap the numbers in ascending order! ";
          this.getContentData.puzzle.tutorial.imgs = "";
          this.getContentData.puzzle.attempts = 0;
          this.getContentData.puzzle.timeout_s = 0;
        }
        if (this.getContentData.type === MINIGAME_TYPE.SWEET_SPOT) {
          this.getContentData.puzzle.puzzleData.default = this.setSweetSpotData();
          this.getContentData.puzzle.lobbyType = "group";
          this.getContentData.puzzle.tutorial.title.en = "Sweet Spot";
          this.getContentData.puzzle.tutorial.txt.en =
            "Hit within the sweet spot!";
          this.getContentData.puzzle.tutorial.imgs = "";
          this.getContentData.puzzle.attempts = 5;
          this.getContentData.puzzle.timeout_s = 0;
        }
        if (this.getContentData.type === MINIGAME_TYPE.SYMBOL_TRAIN) {
          this.getContentData.puzzle.puzzleData.default = this.setSymbolTrainData();
          this.getContentData.puzzle.lobbyType = "group";
          this.getContentData.puzzle.tutorial.title.en = "Symbol Train";
          this.getContentData.puzzle.tutorial.txt.en =
            "Find the images/symbols that match your targets! ";
          this.getContentData.puzzle.tutorial.imgs = "";
          this.getContentData.puzzle.attempts = 5;
          this.getContentData.puzzle.timeout_s = 60;
        }
        if (this.getContentData.type === MINIGAME_TYPE.MARBLE_MAZE) {
          this.getContentData.puzzle.puzzleData.default = this.setMarbleMazeData();
          this.getContentData.puzzle.lobbyType = "group";
          this.getContentData.puzzle.tutorial.title.en = "Marble Maze";
          this.getContentData.puzzle.tutorial.txt.en = "Navigate each maze";
          this.getContentData.puzzle.tutorial.imgs = "";
          this.getContentData.puzzle.attempts = 5;
          this.getContentData.puzzle.timeout_s = 120;
          this.getContentData.puzzle.dismissable = false;
        }
        if (this.getContentData.type === MINIGAME_TYPE.POI_PICKER) {
          this.getContentData.puzzle.puzzleData.default = this.setPoiPickerData();
          this.getContentData.puzzle.lobbyType = "solo";
          this.getContentData.puzzle.tutorial.title.en = "Whodunnit?";
          this.getContentData.puzzle.tutorial.txt.en =
            "Select the culprit(s) from the list!";
          this.getContentData.puzzle.tutorial.imgs = "";
          this.getContentData.puzzle.attempts = 0;
          this.getContentData.puzzle.timeout_s = 0;
          this.getContentData.puzzle.dismissable = true;
        }
        if (this.getContentData.type === MINIGAME_TYPE.INVENTORY_PICKER) {
          this.getContentData.puzzle.puzzleData.default = this.setInventoryPickerData();
          this.getContentData.puzzle.lobbyType = "solo";
          this.getContentData.puzzle.tutorial.title.en = "Item Pick!";
          this.getContentData.puzzle.tutorial.txt.en =
            ": Select the item from the list!";
          this.getContentData.puzzle.tutorial.imgs = "";
          this.getContentData.puzzle.attempts = 0;
          this.getContentData.puzzle.timeout_s = 0;
          this.getContentData.puzzle.dismissable = true;
        }
        if (this.getContentData.type === MINIGAME_TYPE.POINT_TRACE) {
          this.getContentData.puzzle.puzzleData.default = this.setPointTraceData();
          this.getContentData.puzzle.lobbyType = "group";
          this.getContentData.puzzle.tutorial.title.en = "Tracer!";
          this.getContentData.puzzle.tutorial.txt.en =
            "Trace the shapes, starting with the highlighted point(s)";
          this.getContentData.puzzle.tutorial.imgs = "";
          this.getContentData.puzzle.attempts = 3;
          this.getContentData.puzzle.timeout_s = 0;
          this.getContentData.puzzle.dismissable = false;
        }
        if (this.getContentData.type === MINIGAME_TYPE.LOOK_SEEK) {
          this.getContentData.puzzle.puzzleData.default = this.setLookSeekData();
          this.getContentData.puzzle.lobbyType = "group";
          this.getContentData.puzzle.tutorial.title.en = "Look & Seek";
          this.getContentData.puzzle.tutorial.txt.en = "Find the Targets!";
          this.getContentData.puzzle.tutorial.imgs = "";
          this.getContentData.puzzle.attempts = 0;
          this.getContentData.puzzle.timeout_s = 90;
          this.getContentData.puzzle.dismissable = false;
        }
        if (this.getContentData.type === MINIGAME_TYPE.FLING_IT) {
          this.getContentData.puzzle.puzzleData.default = this.setFlingItPuzzleData();
          this.getContentData.puzzle.lobbyType = "group";
          this.getContentData.puzzle.tutorial.title.en = "Fling it";
          this.getContentData.puzzle.tutorial.txt.en = "Hit the Target/s!";
          this.getContentData.puzzle.tutorial.imgs = "";
          this.getContentData.puzzle.attempts = 0;
          this.getContentData.puzzle.timeout_s = 90;
          this.getContentData.puzzle.dismissable = false;
        }
        if (this.getContentData.type === MINIGAME_TYPE.JIGSAW) {
          this.getContentData.puzzle.puzzleData.default = this.setJigsawPuzzleData();
          this.getContentData.puzzle.lobbyType = "group";
          this.getContentData.puzzle.tutorial.title.en = "Jigsaw";
          this.getContentData.puzzle.tutorial.txt.en = "Rearrange the pieces!";
          this.getContentData.puzzle.tutorial.imgs = "";
          this.getContentData.puzzle.attempts = 0;
          this.getContentData.puzzle.timeout_s = 90;
          this.getContentData.puzzle.dismissable = false;
        }
        if (this.getContentData.type === MINIGAME_TYPE.OVERLAYPUZZLE) {
          this.getContentData.puzzle.puzzleData.default = this.setOverlayPuzzleData();
          this.getContentData.puzzle.lobbyType = "group";
          this.getContentData.puzzle.tutorial.title.en = "Overlay Match";
          this.getContentData.puzzle.tutorial.txt.en =
            "Select the correct layers to match the target image";
          this.getContentData.puzzle.tutorial.imgs = "";
          this.getContentData.puzzle.attempts = 0;
          this.getContentData.puzzle.timeout_s = 90;
          this.getContentData.puzzle.dismissable = false;
        }
      }
      this.onValueChanged();
    }
  }

  clearDifficultyValues(): void {
    if (this.difficultyLevel === "easy") {
      delete this.getContentData?.puzzle.puzzleData.easy;
      this.difficultyLevel = "default";
    }
    if (this.difficultyLevel === "hard") {
      delete this.getContentData?.puzzle.puzzleData.hard;
      this.difficultyLevel = "default";
    }
    this.onValueChanged();
  }

  updateData(data: any): void {
    if (this.getContentData !== undefined) {
      this.getContentData.puzzle.puzzleData = data;
    }
    this.onValueChanged();
  }

  @Validations()
  validations = {
    getContentData: {
      puzzle: {
        tutorial: {
          title: {
            en: {
              required,
              minLength: minLength(3),
              maxLength: maxLength(50),
            },
          },
        },
        attempts: {
          numeric,
        },
        styleID: {
          numeric,
        },
        timeout_s: {
          numeric,
        },
      },
    },
  };
}

export default PoiMiniGame;
